window.addEventListener("load", (event) => {
  this.formLogin = document.querySelector("#form-login");
  this.formInfo = document.querySelector("#form-info");
  this.divMaGioiThieu = document.querySelector("#ma-gioi-thieu");

  this.btnLogin = document.querySelector("#btn-login");
  this.btnNewPasscode = document.querySelector("#btn-new-passcode");

  this.voucherBody = document.querySelector("#voucher-body");
  this.fullname = document.querySelector("#fullname");

  this.codeID = document.querySelector("#code-id");
  this.passcode = document.querySelector("#passcode");
  this.newPasscode = document.querySelector("#newpasscode");
  this.newPasscode2 = document.querySelector("#newpasscode2");
  this.itemNewPasscode = document.querySelector("#item-new-passcode");
  this.itemNewPasscode2 = document.querySelector("#item-new-passcode2");

  this.divNewPasscode = document.querySelector("#new-passcode");
  this.actionShowPasscode = document.querySelector("#action-show-passcode");
  this.actionHidePasscode = document.querySelector("#action-hide-passcode");

  this.containerMessage = document.querySelector("#container-message");
  this.successBox = document.querySelector("#success-box");
  this.errorBox = document.querySelector("#error-box");
  this.messageError = document.querySelector("#message-error");
  this.messageSuccess = document.querySelector("#message-success");

  this.divMaGioiThieu.classList.remove("hidden");

  fetch(`https://api.ipify.org/`)
    .then((response) => response.text())
    .then((textIP) => {
      this.textIP = textIP;
    });
});

function clickDangNhap() {
  const voucherHTML = `
      <div class="title-info py-2">THÔNG TIN MÃ GIỚI THIỆU THÁNG title_month CỦA BẠN</div>
      <ul class="list-disc">
        <li>Mã giới thiệu của bạn: <span class="user-code">voucher_serial</span></li>
        <li>Thời gian hiệu lực: <span class="code-date">code_date</span></li>
        <li>Mô tả: Áp dụng giảm giá SP 10% cho người thân của NV</li>
        <li>Hạn mức được cấp: <span class="han-muc">han_muc</span></li>
        <ul class="px-0 mx-0">
          <li>+ Đã sử dung: <span class="su-dung">su_dung</span></li>
          <li>+ Còn lại: <span class="con-lai">con_lai</span></li>
        </ul>
        <li>Đơn hàng sử dụng:</li>
        <ol class="list-decimal">
          order_HTML
        </ol>
      </ul>
    `;
  if (this.codeID.length == 0) {
    thongBaoLoi("Vui Lòng Nhập Mã ID.");
  } else if (isNaN(this.codeID.value)) {
    thongBaoLoi("Mã ID chỉ được nhập số.");
  } else if (this.passcode.value == 0) {
    thongBaoLoi("Vui Lòng Nhập Passcode.");
  } else {
    fetch(`${window.theme.zuciani}/api/web/employee_magioithieu`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ip: this.textIP,
        employee_id: this.codeID.value,
        passcode: this.passcode.value,
      }),
    })
      .then((response) => response.json())
      .then((dataLogin) => {
        console.log(dataLogin);
        if (dataLogin.status) {
          this.formLogin.classList.add("hidden");
          this.formInfo.classList.remove("hidden");
          var voucherBodyHTML = "";
          dataLogin.datas.vouchers.forEach((voucher) => {
            var orderHTML = "";
            const titleMonth = `${voucher.issue_date.split("/")[1]}/${voucher.issue_date.split("/")[2]}`;
            const codeDate = `${voucher.issue_date} - ${voucher.expiry_date}`;
            voucher.used_orders.forEach((order, index) => {
              orderHTML += `<li>${order.partner_name} - ${order.partner_phone} - ${order.name}</li>`;
            });
            voucherBodyHTML += voucherHTML
              .replace("title_month", titleMonth)
              .replace("voucher_serial", voucher.voucher_serial)
              .replace("code_date", codeDate)
              .replace("han_muc", voucher.max_num_apply)
              .replace("su_dung", voucher.num_apply)
              .replace("con_lai", voucher.max_num_apply - voucher.num_apply)
              .replace("order_HTML", orderHTML);
          });
          this.fullname.innerHTML = `${dataLogin.datas.employee_name} (ID: ${dataLogin.datas.employee_id})`;
          this.voucherBody.innerHTML = voucherBodyHTML;
        } else {
          thongBaoLoi(dataLogin.message);
        }
      });
  }
}

function clickEditPasscode() {
  if (isNaN(this.newPasscode.value)) {
    thongBaoLoi("Passcode mới chỉ được nhập số!");
  } else if (this.newPasscode.value.length != 6) {
    thongBaoLoi("Passcode mới chứa 6 kí số 0 đến 9");
  } else if (this.newPasscode.value != this.newPasscode2.value) {
    thongBaoLoi("Passcode không giống nhau.");
  } else {
    fetch(`${window.theme.zuciani}/api/web/employee_change_passcode`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ip: this.textIP,
        employee_id: this.codeID.value,
        passcode: this.passcode.value,
        new_passcode: this.newPasscode.value,
      }),
    })
      .then((response) => response.json())
      .then((dataEdit) => {
        if (dataEdit.status) {
          thongBaoThanhCong(dataEdit.message);
          hideEditPasscode();
        } else {
          thongBaoLoi(dataEdit.message);
        }
      });
  }
}

function thongBaoThanhCong(message) {
  const bodyHTML = document.querySelector("body");
  bodyHTML.classList.add("overflow-baohanh");
  this.containerMessage.classList.remove("hidden");
  this.successBox.classList.remove("hidden");
  this.messageSuccess.innerHTML = message;
}
function thongBaoLoi(message) {
  const bodyHTML = document.querySelector("body");
  bodyHTML.classList.add("overflow-baohanh");
  this.containerMessage.classList.remove("hidden");
  this.errorBox.classList.remove("hidden");
  this.messageError.innerHTML = message;
}
function thongBaoClose() {
  const bodyHTML = document.querySelector("body");
  bodyHTML.classList.remove("overflow-baohanh");
  this.containerMessage.classList.add("hidden");
  this.errorBox.classList.add("hidden");
}
function clickMuaSPKhac() {
  location.href = "/";
}

function showEditPasscode() {
  this.divNewPasscode.classList.remove("visibility");
  this.actionShowPasscode.classList.add("visibility");
  this.actionHidePasscode.classList.remove("visibility");
}

function hideEditPasscode() {
  this.divNewPasscode.classList.add("visibility");
  this.actionShowPasscode.classList.remove("visibility");
  this.actionHidePasscode.classList.add("visibility");
}
